import React, { useEffect, useState } from "react";
import { Button, ButtonGrey } from "../../../../style/Button";
import "./Bill.css";
import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
const PmsDispensedBilling = () => {
  return (
    <>
      <div style={{ display: "flex" }}>
        <div style={{ width: "100%" }}>
          <section
            class="custom-radius border border-secondary customeFormBorder dispensed-table-wrap"
            style={{
              paddingBottom: "0px !important",
              backgroundColor: "white",
              padding:"20px 30px"
            }}
          >
           <Table style={{fontSize:"16px", fontFamily: "work sans"}}>
            <TableHead >
              <TableCell style={{ borderBottom: 'none', fontSize:"16px", fontFamily: "work sans" }}>Date Dispensed</TableCell>
              <TableCell style={{ borderBottom: 'none', fontSize:"16px", fontFamily: "work sans" }}>Rx Name</TableCell>
              <TableCell style={{ borderBottom: 'none', textAlign: 'center', fontSize:"16px", fontFamily: "work sans" }}>Rx Dose</TableCell>
              <TableCell style={{ borderBottom: 'none', textAlign: 'center', fontSize:"16px", fontFamily: "work sans" }}>Orders Status</TableCell>
              <TableCell style={{ borderBottom: 'none', textAlign: 'center', fontSize:"16px", fontFamily: "work sans" }}>Provider</TableCell>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell style={{ borderBottom: 'none', fontSize:"16px", fontFamily: "work sans", color: "#4678ED" }}>Phil Belford</TableCell>
                <TableCell style={{ borderBottom: 'none', fontSize:"16px", fontFamily: "work sans" }}>Medizen</TableCell>
                <TableCell style={{ borderBottom: 'none', textAlign: 'center', fontSize:"16px", fontFamily: "work sans" }}>50/10mg</TableCell>
                <TableCell style={{ borderBottom: 'none', textAlign: 'center', fontSize:"16px", fontFamily: "work sans" }}>Accepted</TableCell>
                <TableCell style={{ borderBottom: 'none', textAlign: 'center', fontSize:"16px", fontFamily: "work sans" }}>Abe Doctor</TableCell>
              </TableRow>
            </TableBody>
           </Table>
          </section>
        </div>
       
      </div>
    </>
  );
}
export default PmsDispensedBilling